import React, {Component, Fragment } from 'react';
import tirepuncture from '../../../images/driverpolicy-images/tire-damage.png';
import check from '../../../images/driverpolicy-images/check.png';
import damage from '../../../images/driverpolicy-images/damage.png';

class Damages extends Component {
	constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
    const { city } = this.props;
  	return(

  		<Fragment>
        <span id='damages' className='anchor2'></span>
  			<div className='damages__content--container'>
            <span className='damages__title--container'>
              <img src={check}/>
              <h3><strong>Damages</strong></h3>
            </span>
            <br/>
         <div className='damages__intro--container'> 
            <p>
              You are responsible for any damage that you do not 
              report before your booking or occurs during your booking.
            </p>
            <br/>
            <p>
              In the case of minor incidents: as an example, if the repair cost to replace and paint a bumper is only $500, 
              then you will only pay $500.
            </p>
            <br/>
            {city === 'new_york' ? (<p>
              For major accidents, the insurance deductible is $1,500. This is the maximum you 
              will pay for any incident. If you are deemed not at fault by the insurance company, you will not have to pay 
              anything.
            </p>):(<p>For major accidents, the insurance deductible is $1,000. This is the maximum you 
              will pay for any incident. If you are deemed not at fault by the insurance company, you will not have to pay 
              anything.</p>)}
          </div>
          <br/>
          <br/>
          <p><strong>How to check for damage before driving</strong></p>
          <div className="block-video">
            <iframe src={`https://www.youtube.com/embed/9GLXhFL_0vs?rel=0`} frameBorder="0" allowFullScreen title="Instructions" />
          </div>
          <div className='damages__inspection--container'> 
            <p>
              You must perform a vehicle inspection before getting inside an Autzu car, of the outside of the vehicle for damages 
              such as scratches and dents. 
            </p>
            <br/>
            <p>
              The best way to do this check is by squatting at the 4 corners of the vehicle, and look for scratches, scuffs, dents, 
              and broken parts. This will take you 1-2 minutes. 
            </p>
            <br/>
            <p>
              Any damage not accompanied by an Autzu damage sticker must be reported 
              in the booking through your Autzu account.
            </p>
            
            <div className='dmg-img'><img  src={damage}/></div>
    
            <p><strong>If you do not report damages before you start a booking, you will be liable for any previously unreported damages to the vehicle at the end of your booking.</strong></p>
          </div>
          <br/>
          <div className='damages__covered--container'> 
           <p><strong>What is covered?</strong></p>
           <ul>
              <li>
                Regular scheduled maintenance - oil changes, brakes, fluids and filters.
              </li>
              <br/>
              <li>
                Mechanical and electrical systems of vehicle.
              </li>
              <br/>
              <li>
                Tire punctures that are repairable.
              </li>
              <br/>    
              <li>
                Regular cleaning of exterior and interior.
              </li>
              <br/>
            </ul>
            <br/>
            <p><strong>What is not covered?</strong></p>
           <ul>
              <li>
                Interior damage (including but not limited to broken charger ports, liquid spills that cause electrical damage, holes or tears in leather seats). 
              </li>
              <br/>    
              <li>
                Exterior damage (including but not limited to scratches, scuffs, dents, rim damages).
              </li>
              <br/>   
              <li>
                Mechanical damage caused by negligence (including but not limited to impact with potholes or curbs).
              </li>
              <br/>
              <li>
                Damage or injuries due to gross negligence (including but not limited to phone use while driving, driving too fast, driving under the influence).
              </li>
              <br/>
              <li>
                Side punctures to tires caused by negligence (including but not limited to potholes or curbs). See image below.
              </li>
              <br/>
              <li className='tire-puncture'>
                <img src={tirepuncture}/>
                <div className='legend'>
                 <div className='legend-container'> 
                  <span className='legend-item'>
                    <div className='circle1'></div>
                    <p>Covered</p>
                  </span>
                  <span className='legend-item'>
                    <div className='circle2'></div>
                    <p>Not Covered</p>
                  </span>
                 </div> 
                </div>
              </li>
            </ul>
          </div>
          <br/>
          <br/>
        </div>
  		</Fragment>

  	)
  }
 }

export default Damages;


// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/Damages.js